import { defineComponent, createElementBlock, openBlock, normalizeClass, createBlock, createTextVNode, createCommentVNode, toDisplayString, normalizeProps, mergeProps, createElementVNode, Fragment, renderList } from 'vue';
import _sfc_main$2 from './basler-components.es81.js';
/* empty css                       */
import _sfc_main$1 from './basler-components.es85.js';
/* empty css                       */

const _hoisted_1 = ["for"];
const _hoisted_2 = {
  key: 3,
  class: "product-variant-select__select-box"
};
const _hoisted_3 = ["id", "disabled"];
const _hoisted_4 = ["value", "selected", "disabled"];
const _hoisted_5 = { class: "product-variant-select__select-overlay" };
const _hoisted_6 = { class: "product-variant-select__select-overlay-label" };
const _hoisted_7 = {
  key: 0,
  class: "product-variant-select__select-overlay-label-info"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductVariantPickerSelect",
  props: {
    id: {},
    label: {},
    labelTooltip: {},
    selectOptions: {},
    isActive: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    isLoading: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const onSelectChange = (event) => {
      if (props.selectOptions) {
        const select = event.target;
        const selectedOption = props.selectOptions[select.selectedIndex].value;
        emit("update:modelValue", selectedOption);
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          "product-variant-select",
          {
            "is-active": props.isActive,
            "is-disabled": props.isDisabled
          }
        ])
      }, [
        _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$1, {
          key: 0,
          type: "block",
          style: { "width": "40%" }
        })) : (openBlock(), createElementBlock("label", {
          key: 1,
          for: _ctx.id,
          class: "product-variant-select__label"
        }, [
          createTextVNode(toDisplayString(_ctx.label) + " ", 1),
          _ctx.labelTooltip ? (openBlock(), createBlock(_sfc_main$2, normalizeProps(mergeProps({ key: 0 }, _ctx.labelTooltip)), null, 16)) : createCommentVNode("", true)
        ], 8, _hoisted_1)),
        _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$1, {
          key: 2,
          type: "block",
          class: "product-variant-select__select-box",
          style: { "width": "40%", "height": "52px" }
        })) : (openBlock(), createElementBlock("div", _hoisted_2, [
          createElementVNode("select", {
            id: _ctx.id,
            class: "product-variant-select__select",
            disabled: props.isDisabled,
            onChange: onSelectChange
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.selectOptions, (option) => {
              return openBlock(), createElementBlock("option", {
                key: option.value,
                value: option.value,
                selected: option.selected,
                disabled: option.disabled || void 0
              }, [
                createTextVNode(toDisplayString(option.label) + " ", 1),
                option.labelInfo ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                  createTextVNode("- " + toDisplayString(option.labelInfo), 1)
                ], 64)) : createCommentVNode("", true)
              ], 8, _hoisted_4);
            }), 128))
          ], 40, _hoisted_3),
          createElementVNode("div", _hoisted_5, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.selectOptions, (option) => {
              return openBlock(), createElementBlock("div", {
                key: option.value,
                class: normalizeClass(["product-variant-select__select-overlay-option", { "is-selected": option.selected }])
              }, [
                createElementVNode("div", _hoisted_6, toDisplayString(option.label), 1),
                option.labelInfo ? (openBlock(), createElementBlock("div", _hoisted_7, toDisplayString(option.labelInfo), 1)) : createCommentVNode("", true)
              ], 2);
            }), 128))
          ])
        ]))
      ], 2);
    };
  }
});

export { _sfc_main as default };
